import { useEffect, useState } from "react";
import {
  Backdrop,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { MainLayoutContainer } from "components/Layout";
import { useGetWellnessResourceByIdQuery } from "graphql/__generated__/hooks";
import { WellnessResource } from "types/wellnessResource";
import CircularProgress from "@mui/material/CircularProgress";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { BREADCRUMB_PAGE } from "components/Breadcrumb/constants";

export function WellnessResourceView() {
  const { organizationId, id } = useParams();
  const [wellnessResource, setWellnessResource] = useState<WellnessResource>(
    {} as WellnessResource,
  );

  const { loading, data } = useGetWellnessResourceByIdQuery({
    variables: { wellness_resource_id: id },
  });

  useEffect(() => {
    if (data) {
      setWellnessResource(data?.wellness_resource_by_pk as WellnessResource);
    }
  }, [data]);

  return (
    <MainLayoutContainer
      title={wellnessResource?.name || "Wellness Resource"}
      breadcrumb={
        organizationId
          ? BREADCRUMB_PAGE.WELLNESS_RESOURCE
          : BREADCRUMB_PAGE.HOME
      }
    >
      <Typography sx={{ mb: 4 }} component="h4" variant="body1">
        {wellnessResource?.description}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={2} maxWidth={450}>
        <TextField
          fullWidth
          value={wellnessResource?.link || ""}
          variant="outlined"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
          size="small"
        />

        <Tooltip title="Open link in a new tab">
          <IconButton
            color="primary"
            sx={{ p: "10px" }}
            aria-label="directions"
            target="_blank"
            href={wellnessResource?.link}
          >
            <OpenInNewIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <Stack direction="column" alignItems="center">
          <CircularProgress color="inherit" />
          <Typography variant="subtitle2" noWrap>
            Signing In...
          </Typography>
        </Stack>
      </Backdrop>
    </MainLayoutContainer>
  );
}
